import GeneratedLibraryHistoryDataStore from "./generated/GeneratedLibraryHistoryDataStore"

class LibraryHistoryDataStore extends GeneratedLibraryHistoryDataStore {

}

export const libraryHistoryDataStore = new LibraryHistoryDataStore()
